import { render, staticRenderFns } from "./ForumDetails.vue?vue&type=template&id=1d3bf5e3&scoped=true"
import script from "./ForumDetails.vue?vue&type=script&lang=js"
export * from "./ForumDetails.vue?vue&type=script&lang=js"
import style0 from "./ForumDetails.vue?vue&type=style&index=0&id=1d3bf5e3&prod&scoped=true&lang=css"
import style1 from "./ForumDetails.vue?vue&type=style&index=1&id=1d3bf5e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3bf5e3",
  null
  
)

export default component.exports